import React from 'react';
import classnames from 'classnames';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';
import { PrimaryButton } from 'scy/buttons';
import { ProductImage } from 'scy/ProductImage';
import Container from './Container';
import Title from './Title';
import Subtitle from './Subtitle';
import VolumeAndPrice from './VolumeAndPrice';
import ProductDiscount from './ProductDiscount';
import styles from '../styles.mod.scss';
import { textLeft, noUnderline } from 'scy/utils.mod.scss';
import padding from 'scy/padding.mod.scss';

export default function ProductGridItem({
  product,
  includeItemProps,
  lazyLoad,
  raiseOnHover,
  onButtonClick,
  onContainerClick,
  buttonText = 'Add',
  linkProps,
  className
}) {
  return (
    <Container
      soldout={product.soldout}
      itemScope={includeItemProps}
      itemType={includeItemProps ? 'http://schema.org/ListItem' : undefined}
      className={classnames(className, { [styles.raiseOnHover]: raiseOnHover })}
      onClick={onContainerClick}
    >
      <LinkWrapper linkProps={linkProps}>
        <LazyWrapper lazyLoad={lazyLoad}>
          <ProductImage
            product={product}
            alt={product.title}
            itemProp={includeItemProps ? 'image' : undefined}
          />
        </LazyWrapper>

        <div className={classnames(padding.xs, textLeft)}>
          <Title
            title={product.title}
            soldout={product.soldout}
            includeItemProps={includeItemProps}
          />
          <Subtitle
            subtitle={product.subtitle}
            includeItemProps={includeItemProps}
          />
          <VolumeAndPrice
            volume={product.volume}
            price={product.price}
            regularPrice={product.regular_price}
          />
          <ProductDiscount product={product} />
        </div>

        {!!onButtonClick && (
          <div className={styles.hoverable}>
            {!product.price ? null : (
              <PrimaryButton
                className={styles.raisedButton}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  onButtonClick(product);
                }}
              >
                {buttonText}
              </PrimaryButton>
            )}
          </div>
        )}
      </LinkWrapper>
    </Container>
  );
}

function LazyWrapper({ lazyLoad, children }) {
  return lazyLoad ? (
    <LazyLoad once={true} height={200} offset={150}>
      {children}
    </LazyLoad>
  ) : (
    children
  );
}

function LinkWrapper({ linkProps, children }) {
  return linkProps ? (
    <Link {...linkProps} className={noUnderline}>
      {children}
    </Link>
  ) : (
    children
  );
}
